module.exports = __webpack_public_path__ + "static/media/react-logo.5d5d9eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/react-logo.svg
// module id = 642
// module chunks = 0